<template>
  <span>{{ $options.formatRelative(new Date(value * 1000), new Date()) }}</span>
</template>

<script>
import { formatRelative } from "date-fns";

export default {
  formatRelative,

  props: {
    value: [String, Number],
  },
};
</script>
